import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { QualificationsModalComponent } from '../employe-access/qualifications-modal/qualifications-modal.component';
import { ModErrorComponent } from '../modals/mod-error/mod-error.component';
import { SelfVerificationService } from '../service/self-verification.service';


@Component({
  selector: 'app-visitor-verification-list',
  templateUrl: './visitor-verification-list.component.html',
  styleUrls: ['./visitor-verification-list.component.css']
})
export class VisitorVerificationListComponent implements OnInit {

  accesses : any[];
  person:any;
  email:any;
  rut:any;
  accessDetail:any[];
  typePeopleContractor:boolean;
  titulo: any;

  constructor(private dataApi: SelfVerificationService,
              private _snackBar: MatSnackBar,
              public dialog: MatDialog,
              private spinner: NgxSpinnerService,
              private route: ActivatedRoute,) {
                 this.route.snapshot.paramMap.get('email');
                 this.email = this.route.snapshot.paramMap.get('email');
                 this.rut = this.route.snapshot.paramMap.get('rut');
                 this.titulo = this.route.snapshot.paramMap.get('type');
              }

  ngOnInit() {
    //this.titulo = "RUT";
    //aqui abrir spinner
      this.searchPerson(this.email,this.rut);


  }

  searchPerson(email,rut){
    this.spinner.show();
      this.dataApi.getSearchVisitorbyMailRut(email,rut).subscribe(
        (data: any)=>{
          if(data==null || data==undefined || data.length==0){
            this.person= [];
          }else{
            this.person=  data[0];
            if(this.person.employeeType == "Employee")
                this.typePeopleContractor = false;
            else
                this.typePeopleContractor = true;
            this.getAuthorisedVisitorAccessesSelfCheck(email,rut)
             if(data[0].hasOwnProperty("passportNumber")) {
               //this.titulo =this.getlang()==='en'?"Passport":"Pasaporte";
               //this.person.nationalId = data[0]["passportNumber"];
             }
             else {
              //this.titulo ="RUT";

             }
          }
          this.spinner.hide();
        },
        (err: any)=>{

          this.person= null;
          this.spinner.hide();
        }
      );

    }

  getAuthorisedVisitorAccessesSelfCheck(email,rut)
  {
    this.spinner.show();
    this.dataApi.getAuthorisedVisitorAccessesSelfCheck(email,rut).subscribe(
      (data: any)=>{
        if(data==null || data==undefined || data.length==0){
          this.accesses= [];
          this.spinner.hide()
        }else{
          this.accesses=data.myAccesses;

          // this.accessDetail=data.myAccesses.accessDetail
          this.spinner.hide()
        }this.spinner.hide();
        //hide spinner
      },
      (err: any)=>{
        this.accesses=[];
        this.spinner.hide();
      }
    );

  }
  seeQualifications(qualifications) {
    this.dialog.open(QualificationsModalComponent, { panelClass: 'myapp-no-padding-dialog', data: qualifications });
  }
  getlang(){
    return sessionStorage.getItem('lang');
  }


}
